import React, { useState, useContext, useEffect } from 'react';
import VerbsWPrepositionsQuiz from './grammarcomponents/VerbsWPrepositionsQuiz';
import VerbConjugationsQuiz from './grammarcomponents/VerbConjugationsQuiz';
import ArticlesQuiz from './grammarcomponents/ArticlesQuiz';
import PrepositionsQuiz from './grammarcomponents/PrepositionsQuiz';
import PluralsQuiz from './grammarcomponents/PluralsQuiz.jsx';
import { GameContext } from '../../GameContext';

const quizNames = {
  defaultOption: "Grammar Trainer",
  verbsWPrepositions: "Verbs with Prepositions",
  verbConjugations: "Verb Conjugation",
  articles: "Articles Quiz",
  prepositions: "Prepositions Quiz",
  plurals: "Plurals Quiz"
};
const quizComponents = {
  verbsWPrepositions: VerbsWPrepositionsQuiz,
  verbConjugations: VerbConjugationsQuiz,
  articles: ArticlesQuiz,
  prepositions: PrepositionsQuiz,
  plurals: PluralsQuiz
};

const GrammarTrainer = () => {
  const [selectedQuiz, setSelectedQuiz] = useState('');
  const [feedback, setFeedback] = useState('');
  const [tip, setTip] = useState('');
  const [quizName, setQuizName] = useState(quizNames.defaultOption);
  const [shouldEndQuiz, setShouldEndQuiz] = useState(false);
  const [pendingQuizChange, setPendingQuizChange] = useState(null);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [answersList, setAnswersList] = useState([])
  const { selectedLanguage, triggerGameEnd, onGameEndComplete, setGameActiveStatus, resultsWord, grammarOptions } = useContext(GameContext);

  useEffect(() => {
    if (!isTransitioning && pendingQuizChange !== null) {
      console.log('Completing quiz transition to:', pendingQuizChange);
      setSelectedQuiz(pendingQuizChange);
      console.log('pending QUiz change is true')
      setQuizName(quizNames[pendingQuizChange] || quizNames.defaultOption);
      setPendingQuizChange(null);
    }
  }, [isTransitioning, pendingQuizChange]);

  const handleGrammarQuizChange = (event) => {
    const newValue = event.target.value;
    console.log('handling handleGrammarQuizChange - ', newValue)

    if (selectedQuiz && newValue !== selectedQuiz) {
      console.log('selectedQuiz && newValue !== selectedQuiz all true')
      setIsTransitioning(true);
      setShouldEndQuiz(true);
      setPendingQuizChange(newValue);
    } else {
      setSelectedQuiz(newValue);
      setQuizName(quizNames[newValue] || quizNames.defaultOption);
    }
  };

  const handleResultUpdate = (results) => {
    setFeedback(results.feedback);
    setTip(results.tip);
    if (results.answersGiven && results.answersGiven.length > 0) {
      setAnswersList(results.answersGiven);
  } else {
      setAnswersList([]); // Set to empty array if no data
  }
  };

  const handleEndComplete = () => {
    console.log('Firing handleEndComplete')
    setShouldEndQuiz(false);
    setIsTransitioning(false);
  };

  const renderAnswers = () => {
  if (quizName === 'Articles Quiz') {
    return answersList.map((row, index) => (
      <tr key={index} className="border-0">
        <td className={`p-0 border-0 ${String(row[2]).toLowerCase() === 'true' ? 'text-success' : 'text-danger'}`}
            style={{width: "30px"}}>
          {row[0]}
        </td>
        <td className="p-0 border-0">
          {row[1]}
        </td>
      </tr>
    ));
  } else if (quizName === 'Plurals Quiz'){
      return answersList.map((row, index) => (
      <tr key={index} className="border-0">
        <td className="p-0 border-0"
            style={{width: "50px"}}>
            {row[0]}</td>   
        <td className={`p-0 border-0 ${String(row[2]).toLowerCase() === 'true' ? 'text-success' : 'text-danger'}`}
            style={{width: "30px"}}>
            die {row[1]}
        </td>
      </tr>
      ));
  } else {
    return answersList.map((row, index) => (
      <tr key={index} className="border-0">
        <td className="p-0 border-0">{row[0]} - {row[1]}</td>
      </tr>
    ));
  }
};

  const SelectedQuizComponent = quizComponents[selectedQuiz];

  return (
    <div class="container">
      <h1 class="mb-0 slackey-regular">{quizName}</h1>
        <div class="row mt-4">
          <div class="col-md-6">
              <div class="card rounded-0">
                  <div class="card-body">
                        {SelectedQuizComponent ? (
                          <SelectedQuizComponent 
                          shouldEnd={shouldEndQuiz}
                          onResultUpdate={handleResultUpdate}
                          onEndComplete={handleEndComplete}
                          />
                        ) : (
                          <p className="custom-text-primary">Please select a grammar exercise</p>
                        )}
                      <p id="grammarOutput" class = "outputs"></p>
                  </div>
            </div>
        </div>
          <div class="col-md-6">
            <div class="card border-0">
              <div class="card-body">
                <div class="form-group">
                <select 
                  className="form-control" 
                  id="grammarControlSelect1" 
                  onChange={handleGrammarQuizChange}
                  value={selectedQuiz}
                >
                  <option value="" className="custom-text-primary fw-bold">Select Exercise</option>
                  {grammarOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
                </div>
              </div>
            </div>
            <div class="card rounded-0">
                <div class="card-body">
                    <h4 class="card-title" id="results-name-1">{resultsWord}</h4>
                    <p class="card-text" id ="resultsDisplay">{feedback}</p>
                    {tip && tip.trim() !== '' && <p className="card-text" id="tipDisplay"><span className="fw-bold">Tip:</span>  {tip}</p>}
                    <table className="table">
                      <tbody>
                        {renderAnswers()}
                      </tbody>
                    </table>
                  
                </div>
            </div>
            </div>
        </div>
    </div>
  );
};

export default GrammarTrainer;